export enum CheckListsActionsEnum {
  CHECK_LISTS_INIT_PAGE = 'CHECK_LISTS_INIT_PAGE',
  CHECK_LISTS_RESET_PAGE = 'CHECK_LISTS_RESET_PAGE',
  CHECK_LISTS_GET_TEMPLATE_LIST = 'CHECK_LISTS_GET_TEMPLATE_LIST',
  CHECK_LISTS_SET_TEMPLATE_LIST = 'CHECK_LISTS_SET_TEMPLATE_LIST',
  CHECK_LISTS_GET_TEMPLATE_LIST_NEXT_PAGE = 'CHECK_LISTS_GET_TEMPLATE_LIST_NEXT_PAGE',
  CHECK_LISTS_SET_ACTIVE_TEMPLATE_ID = 'CHECK_LISTS_SET_ACTIVE_TEMPLATE_ID',
  CHECK_LISTS_UPDATE = 'CHECK_LISTS_UPDATE',
  CHECK_LISTS_DELETE = 'CHECK_LISTS_DELETE',
  CHECK_LISTS_CHANGE_DEFAULT = 'CHECK_LISTS_CHANGE_DEFAULT',
  CHECK_LISTS_EXPORT_BY_ID = 'CHECK_LISTS_EXPORT_BY_ID',
  CHECK_LISTS_FORM_SUBMIT = 'CHECK_LISTS_FORM_SUBMIT',
  CHECK_LISTS_FORM_QUESTION_DELETE = 'CHECK_LISTS_FORM_QUESTION_DELETE',
}
